$(document).ready(function(){
  /* Header */
var mobileMenu = $(".js-mobile-menu");
$(document).on('click', '.js-header-burger', function() {
  $('.js-mobile-menu').toggleClass('open');
  $('body').toggleClass('fixed');
})
$(document).mouseup(function (e){
  if (!mobileMenu.is(e.target)
    && mobileMenu.has(e.target).length === 0) {
    mobileMenu.removeClass('open');
    $('body').removeClass('fixed');
  }
});

$(document).on('click', '.js-full-view', function() {
  $(this).hide();
  $(this).closest('.m-learn__block-info').find('.m-lst-part').slideDown(); 
})

/* FAQ*/
$(document).on('click', '.js-question', function() {
  $(this).toggleClass('open'); 
  $(this).next().slideToggle(); 
})
function getOS() {
  let userAgent = window.navigator.userAgent.toLowerCase(),
    macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
    windowsPlatforms = /(win32|win64|windows|wince)/i,
    iosPlatforms = /(iphone|ipad|ipod)/i

  if (macosPlatforms.test(userAgent) || iosPlatforms.test(userAgent)) {
    $('.js-ios').addClass('ios-styles');
  }
}
getOS()


if($('.product').length > 0) {

  /** Product expand */
  function addExpandButton() {
    let list = $('.js-expand-list');
    if($(list).height() > 115) {
      $('.js-expand').show();
    } else {
      $('.js-expand').hide();
    }
  }
  addExpandButton();

  $(document).on('click', '.js-expand', function(e) {
    e.preventDefault();
    $(this).closest('.product-expand-wrapper').addClass('open');
    $('.js-expand').hide();
  })

  /* Recharge widget */
  function correctRechargeStorefront() {
    if($('.rc-radio--active').length > 0) {
      //$('.js-variants').appendTo(".rc-radio--active");
      correctPurchaseLabel();
      correctSubscriptionLabel();
      if($('.subscription-radio').hasClass('rc-radio--active')) {
        setOptionsForWidget('bottom');
        changeSelect();
      } else {
        setOptionsForWidget('top');
      }
    }
  }
  let productId = $('.product').data("product"),
      rechargeWidget = document.getElementById(`RechargeWidget_${productId}`),
      loadRecharge = new MutationObserver(mutationRecords => {
      correctRechargeStorefront();
  });
  loadRecharge.observe(rechargeWidget, {
    childList: true
  });

  correctRechargeStorefront();

  /* Correct widget labels */
  function correctPurchaseLabel() {
    // price = Number(label.replace(/[^0-9\s]/g, '').replace(/,/, '.').trim()),
    let label = $('.onetime-radio .rc-radio__label').text(),
        rawPrice = Number(label.match(/\$\d+(?:\.\d{2})?/)[0].replace('$', '')),
        price = (Number(label.match(/\$\d+(?:\.\d{2})?/)[0].replace('$', '')))
        .toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
        }),
        oldPrice = (Number((label.match(/\d+(?:\,\d+)?/g)[0]).replace(/,/, '.')))
          .toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
          }),
        str = label.replace(/\$|,/g, '').replace(/[0-9]/g, '').replace("USD", "");
        strTrim = str.replace(" .","");
        console.log({rawPrice},{price},{str});
    if($('.onetime-radio .rc-custom-label').length === 0) {
      $('.onetime-radio').append("<span class='rc-custom-label'></span>");
      $('.rc-custom-label').insertAfter($('.onetime-radio .rc-radio__input'));
    }
    $('.onetime-radio .rc-custom-label').html(`${strTrim} <b>${price}</b>`);
    return price;
  }

  function correctSubscriptionLabel() {
    let label = $('.rc-radio__subscription').text(),
        labelWithoutNumbers = label.replace(/\%|,/g, '')
          .replace(/[0-9]/g, '')
          .replace("USD", ""),
        priceText = $('.rc-radio__price').text(),

        oldPriceRaw = (Number($('.rc-radio__price')
          .text()
          .match(/\d+(?:\,\d+)?/g)[0].replace(/,/, '.')))
          .toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }),
          price = (Number($('.rc-radio__price')
            .text()
            .match(/\d+(?:\,\d+)?/g)[0].replace(/,/, '.')))
            .toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),

        oldPrice = $('.onetime-radio .rc-custom-label b').text(),
        discount = checkWidgetDiscount();
        labelWithoutNumbersTrim = labelWithoutNumbers.trim();
        console.log({label},{priceText},{price},{oldPrice},{discount},{labelWithoutNumbers});
    if($('.subscription-radio .rc-custom-label').length === 0) {
      $('.subscription-radio').append("<span class='rc-custom-label'></span>");
      $('.subscription-radio .rc-custom-label').insertAfter($('.subscription-radio .rc-radio__input'));
    }
    if(discount.length > 0) {
      $('.subscription-radio .rc-custom-label').html(
        `${labelWithoutNumbersTrim} 
          <div>
            <b class="rc-old-price">${oldPrice}</b>
            <b class="rc-new-price">${priceText}</b>
          </div>
        `
      );
    } else {
      $('.subscription-radio .rc-custom-label').html(
        `${labelWithoutNumbersTrim} 
          <div>
            <b class="rc-new-price">${price}</b>
          </div>
        `
      );
    }
  }
  
  /* subscribtion events */
  setTimeout(function(){
    $(".onetime-radio .rc-radio__label").on('DOMSubtreeModified',function(){
      correctPurchaseLabel();
      correctSubscriptionLabel();
    });

     /* Widget radio changed */
    $('.rc-radio__input').change(function(){
      correctRechargeStorefront();
    })
  }, 1000)

  /* Custom select */
  function changeSelect() {
    let options = [],
        targetValue = '',
        customSelect = $('.rc-template__radio select');
    
    $('.rc-selling-plans').prepend('<div id="selling-selector"></div>')
    $('.rc-template__radio select option').each(function( index ) {
      options.push([$(this).val(), $(this).text()])
      if(index === 0) {
        targetValue = $(this).val();
      }
    })

    const select = new CustomSelect('#selling-selector', {
      name: 'selling',
      targetValue: targetValue,
      options: options,
      onSelected(select) {
        $(customSelect).val(select.value);
        let elem = document.querySelector('.rc-selling-plans-dropdown__select')
        elem.dispatchEvent(new Event('change'));
      }
    })
  }
}


  /* testimonial rotator */
  var mySwiper = new Swiper('.swiper-container', {

    fadeEffect: {
      crossFade: true
    },
    loop: true,
    effect: 'fade',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });


})

function setOptionsForWidget(position) {
let discount = checkWidgetDiscount(),
    option = $('.js-variants').data('option');

    console.log("setOptionsForWidget", position, option, discount);

if($('.selling-options').length > 0) {
  $('.selling-options').remove();
}

var radios = document.querySelectorAll('variant-radios input[type="radio"]');

// Initialize a variable to store the value of the checked radio
var checkedValue = null;

// Iterate over the radio buttons to find the checked one
for (var i = 0; i < radios.length; i++) {
  if (radios[i].checked) {
    checkedValue = radios[i].value.toLowerCase();
    break; // Exit the loop once the checked radio button is found
  }
}
var checkBullet = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" class="bullet-point-check">
<path d="M10.0996 3.84155L4.59961 9.34155L2.09961 6.84155" stroke="#0F2E2F" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

if(discount > 0) {
  if(position === "bottom") {
   if (checkedValue.includes("everyday")) {
      $('.rc-selling-plans').append(`
      <p class="selling-options selling-options-bottom"><span class='product-option-item'>${checkBullet} 24 Servings</span>
      <span class='product-option-item'>${checkBullet} Pause or Cancel Anytime</span>
      <span class='product-option-item'>${checkBullet} 60-Day Money Back Guarantee</span>
      <span class='product-option-item'>${checkBullet} Free Shipping</span></p>
      `)
    } else if (checkedValue.includes("performance")) {
      $('.rc-selling-plans').append(`
      <p class="selling-options selling-options-bottom"><span class='product-option-item'>${checkBullet} 30 Servings</span>
      <span class='product-option-item'>${checkBullet} Pause or Cancel Anytime</span>
      <span class='product-option-item'>${checkBullet} 60-Day Money Back Guarantee</span>
      <span class='product-option-item'>${checkBullet} Free Shipping</span></p>
      `)
    } else {
      $('.rc-selling-plans').append(`
      <p class="selling-options selling-options-bottom"><span class='product-option-item'>${checkBullet} 30 Servings</span>
      <span class='product-option-item'>${checkBullet} Pause or Cancel Anytime</span>
      <span class='product-option-item'>${checkBullet} 60-Day Money Back Guarantee</span>
      <span class='product-option-item'>${checkBullet} Free Shipping</span></p>
      `)
    }
  } else {
    if (checkedValue.includes("everyday")) {
      $('.onetime-radio').append(`
      <p class="selling-options selling-options-top"><span class='product-option-item'>${checkBullet} 24 Servings</span><span class='product-option-item'>${checkBullet} Free Shipping</span></p>
      `)
    } else if (checkedValue.includes("performance")) {
      $('.onetime-radio').append(`
      <p class="selling-options selling-options-top"><span class='product-option-item'>${checkBullet} 30 Servings</span><span class='product-option-item'>${checkBullet} Free Shipping</span></p>
      `)
    } else {
      $('.onetime-radio').append(`
      <p class="selling-options selling-options-top"><span class='product-option-item'>${checkBullet} 24 Servings</span>
      <span class='product-option-item'>${checkBullet} Free Shipping</span></p>
      `)
    }
  }
} else {
  if(position === "bottom") {
    $('.rc-selling-plans').append(`
      <div class="selling-options selling-options-bottom">
        ${option}
      </div>
    `)
  } else {
    $('.subscription-radio').append(`
    <div class="selling-options selling-options-top">
      ${option}
    </div>
    `)
  }
}
}
function checkWidgetDiscount() {
let label = $('.rc-radio__subscription').text(),
    discount = label.replace(/[^0-9]/g,"");

return discount;
}

class CustomSelect {
constructor(target, params) {
  this._elRoot = typeof target === 'string' ? document.querySelector(target) : target;
  this._params = params || {};
  this._onClickFn = this._onClick.bind(this);
  if (this._params.options) {
    this._elRoot.classList.add('select');
    this._elRoot.innerHTML = CustomSelect.template(this._params);
  }
  this._elToggle = this._elRoot.querySelector('[data-select="toggle"]');
  this._elRoot.addEventListener('click', this._onClickFn);
}
_onClick(e) {
  const target = e.target;
  const type = target.closest('[data-select]').dataset.select;
  if (type === 'toggle') {
    this.toggle();
  } else if (type === 'option') {
    this._changeValue(target);
  }
}
_update(option) {
  option = option.closest('.select__option');
  const selected = this._elRoot.querySelector('.select__option_selected');
  if (selected) {
    selected.classList.remove('select__option_selected');
  }
  option.classList.add('select__option_selected');
  this._elToggle.textContent = option.textContent;
  this._elToggle.value = option.dataset['value'];
  this._elToggle.dataset.index = option.dataset['index'];
  this._elRoot.dispatchEvent(new CustomEvent('select.change'));
  this._params.onSelected ? this._params.onSelected(this, option) : null;
  return option.dataset['value'];
}
_reset() {
  const selected = this._elRoot.querySelector('.select__option_selected');
  if (selected) {
    selected.classList.remove('select__option_selected');
  }
  this._elToggle.textContent = 'Select from list';
  this._elToggle.value = '';
  this._elToggle.dataset.index = -1;
  this._elRoot.dispatchEvent(new CustomEvent('select.change'));
  this._params.onSelected ? this._params.onSelected(this, null) : null;
  return '';
}
_changeValue(option) {
  if (option.classList.contains('select__option_selected')) {
    return;
  }
  this._update(option);
  this.hide();
}
show() {
  document.querySelectorAll('.select_show').forEach(select => {
    select.classList.remove('select_show');
  });
  this._elRoot.classList.add('select_show');
}
hide() {
  this._elRoot.classList.remove('select_show');
}
toggle() {
  if (this._elRoot.classList.contains('select_show')) {
    this.hide();
  } else {
    this.show();
  }
}
dispose() {
  this._elRoot.removeEventListener('click', this._onClickFn);
}
get value() {
  return this._elToggle.value;
}
set value(value) {
  let isExists = false;
  this._elRoot.querySelectorAll('.select__option').forEach((option) => {
    if (option.dataset['value'] === value) {
      isExists = true;
      return this._update(option);
    }
  });
  if (!isExists) {
    return this._reset();
  }
}
get selectedIndex() {
  return this._elToggle.dataset['index'];
}
set selectedIndex(index) {
  const option = this._elRoot.querySelector(`.select__option[data-index="${index}"]`);
  if (option) {
    return this._update(option);
  }
  return this._reset();
}
}

CustomSelect.template = params => {
const name = params['name'];
const options = params['options'];
const targetValue = params['targetValue'];
const items = [];
let selectedIndex = -1;
let selectedValue = '';
let selectedContent = 'Select from list';
options.forEach((option, index) => {
  let selectedClass = '';
  if (option[0] === targetValue) {
    selectedClass = ' select__option_selected';
    selectedIndex = index;
    selectedValue = option[0];
    selectedContent = option[1];
  }
  items.push(`<li class="select__option${selectedClass}" data-select="option" data-value="${option[0]}" data-index="${index}">${option[1]}</li>`);
});
return `<button type="button" class="select__toggle" name="${name}" value="${selectedValue}" data-select="toggle" data-index="${selectedIndex}">${selectedContent}</button>
<div class="select__dropdown">
  <ul class="select__options">${items.join('')}</ul>
</div>`;
};

document.addEventListener('click', (e) => {
if (!e.target.closest('.select')) {
  document.querySelectorAll('.select_show').forEach(select => {
    select.classList.remove('select_show');
  });
}
});

$(document).ready(function(){
if($('#ContactForm-request-type').length > 0) {
  let options = [],
    targetValue = '',
    customSelect = $('#ContactForm-request-type');

  $('#ContactForm-request-type option').each(function( index ) {
    options.push([$(this).val(), $(this).text()])
    if(index === 0) {
      targetValue = $(this).val();
    }
  })

  const select = new CustomSelect('#CustomRequest-select', {
    name: 'request',
    targetValue: targetValue,
    options: options,
    onSelected(select) {
      $(customSelect).val(select.value);
    }
  })
}
/*
  const dataValue = $('.product__info-container').data('loaded-variant-subscription-info');
  const oneTimeDataValue = $('.product__info-container').data('loaded-variant-one-time-info');
  const formattedDataValue = dataValue.replace(/\n/g, '<br>');
  const formattedDataValueOneTime = oneTimeDataValue.replace(/\n/g, '<br>');
  $('.selling-options-bottom').html(formattedDataValue);
  $('.selling-options-top').html(formattedDataValueOneTime);
  no error checking!
  */
  const $productInfoContainer = $('.product__info-container');
  const $sellingOptionsBottom = $('.selling-options-bottom');
  const $sellingOptionsTop = $('.selling-options-top');

  if ($productInfoContainer.length) {
    const dataValue = $productInfoContainer.data('loaded-variant-subscription-info');
    const oneTimeDataValue = $productInfoContainer.data('loaded-variant-one-time-info');

    if (dataValue) {
      const formattedDataValue = dataValue.replace(/\n/g, '<br>');
      if ($sellingOptionsBottom.length) {
        $sellingOptionsBottom.html(formattedDataValue);
      }
    }

    if (oneTimeDataValue) {
      const formattedDataValueOneTime = oneTimeDataValue.replace(/\n/g, '<br>');
      if ($sellingOptionsTop.length) {
        $sellingOptionsTop.html(formattedDataValueOneTime);
      }
    }
  }
})

document.addEventListener("DOMContentLoaded", function() {
  console.log("searching for bad links");
  var anchors = document.querySelectorAll('a[href*="/blogs/news/"]');
  anchors.forEach(function(anchor) {
    console.log("old news link", anchor.href);
    anchor.href = anchor.href.replace("/blogs/news/", "/blogs/learn/");
  });
});

// Add this to the end of your custom.js file
// Fix for ensuring onetime purchase options always appear

function ensureOnetimeOptions() {
  // Check if we have the recharge widget
  if (!document.querySelector('.onetime-radio')) return;
  
  // Remove any existing selling options from onetime radio to avoid duplicates
  const existingOptions = document.querySelector('.onetime-radio .selling-options');
  if (existingOptions) {
    existingOptions.remove();
  }
  
  // Get the checked variant to determine serving size
  const radios = document.querySelectorAll('variant-radios input[type="radio"]');
  let checkedValue = null;
  
  for (let i = 0; i < radios.length; i++) {
    if (radios[i].checked) {
      checkedValue = radios[i].value.toLowerCase();
      break;
    }
  }
  
  // Check if onetime radio is active
  const onetimeRadio = document.querySelector('.onetime-radio');
  const isOnetimeActive = onetimeRadio && onetimeRadio.classList.contains('rc-radio--active');
  
  // Only add options if onetime is active
  if (onetimeRadio && isOnetimeActive) {
    // SVG for checkmarks
    const checkBullet = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" class="bullet-point-check">
      <path d="M10.0996 3.84155L4.59961 9.34155L2.09961 6.84155" stroke="#0F2E2F" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    
    // Determine serving size based on variant
    let servings = "24 Servings"; // default
    if (checkedValue && checkedValue.includes("performance")) {
      servings = "30 Servings";
    } else if (checkedValue && checkedValue.includes("everyday")) {
      servings = "24 Servings";
    }
    
    const optionsHTML = `
      <p class="selling-options selling-options-top">
        <span class='product-option-item'>${checkBullet} ${servings}</span>
        <span class='product-option-item'>${checkBullet} Free Shipping</span>
      </p>
    `;
    onetimeRadio.insertAdjacentHTML('beforeend', optionsHTML);
  }
}

function ensureSubscriptionOptions() {
  // Check if we have the recharge widget and subscription options
  if (!document.querySelector('.subscription-radio')) return;
  
  // Remove any existing selling options from subscription areas to avoid duplicates
  const existingOptionsBottom = document.querySelector('.rc-selling-plans .selling-options');
  if (existingOptionsBottom) {
    existingOptionsBottom.remove();
  }
  
  // Get the checked variant to determine serving size
  const radios = document.querySelectorAll('variant-radios input[type="radio"]');
  let checkedValue = null;
  
  for (let i = 0; i < radios.length; i++) {
    if (radios[i].checked) {
      checkedValue = radios[i].value.toLowerCase();
      break;
    }
  }
  
  // SVG for checkmarks
  const checkBullet = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" class="bullet-point-check">
    <path d="M10.0996 3.84155L4.59961 9.34155L2.09961 6.84155" stroke="#0F2E2F" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
  
  // Determine serving size based on variant
  let servings = "24 Servings"; // default
  if (checkedValue && checkedValue.includes("performance")) {
    servings = "30 Servings";
  } else if (checkedValue && checkedValue.includes("everyday")) {
    servings = "24 Servings";
  }
  
  // Add subscription options to the rc-selling-plans container
  const sellingPlans = document.querySelector('.rc-selling-plans');
  if (sellingPlans) {
    const optionsHTML = `
      <p class="selling-options selling-options-bottom">
        <span class='product-option-item'>${checkBullet} ${servings}</span>
        <span class='product-option-item'>${checkBullet} Pause or Cancel Anytime</span>
        <span class='product-option-item'>${checkBullet} 60-Day Money Back Guarantee</span>
        <span class='product-option-item'>${checkBullet} Free Shipping</span>
      </p>
    `;
    sellingPlans.insertAdjacentHTML('beforeend', optionsHTML);
  }
}

// Run the fixes when variants change
document.addEventListener('DOMContentLoaded', function() {
  // Initial load
  setTimeout(function() {
    ensureOnetimeOptions();
    ensureSubscriptionOptions();
  }, 1000);
  
  // Listen for variant changes
  const variantSelectors = document.querySelectorAll('variant-radios input[type="radio"], variant-selects select');
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      // Small delay to let other scripts run first
      setTimeout(function() {
        ensureOnetimeOptions();
        ensureSubscriptionOptions();
      }, 100);
    });
  });
  
  // Also listen for recharge widget changes
  const rechargeInputs = document.querySelectorAll('.rc-radio__input');
  rechargeInputs.forEach(input => {
    input.addEventListener('change', function() {
      setTimeout(function() {
        ensureOnetimeOptions();
        ensureSubscriptionOptions();
      }, 100);
    });
  });
  
  // Use MutationObserver as a backup to catch any DOM changes
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if recharge widget elements were modified
        const target = mutation.target;
        if (target.classList && (target.classList.contains('onetime-radio') || 
            target.classList.contains('rc-selling-plans') ||
            target.closest && target.closest('.recharge-subscription-widget'))) {
          shouldCheck = true;
        }
      }
    });
    
    if (shouldCheck) {
      setTimeout(function() {
        ensureOnetimeOptions();
        ensureSubscriptionOptions();
      }, 200);
    }
  });
  
  // Start observing
  const rechargeWidget = document.querySelector('.recharge-subscription-widget');
  if (rechargeWidget) {
    observer.observe(rechargeWidget, {
      childList: true,
      subtree: true
    });
  }
});